// eslint-disable-next-line import/prefer-default-export
export const getUbigeos = async () => {
  const ubigeoEnv = process.env.VUE_APP_ENV === 'development' ? 'development' : 'production';
  const ubigeoUrl = `https://cdn.joinnus.com/files_cache/ubigeos-${ubigeoEnv}.json`;
  const res = await fetch(ubigeoUrl);
  const { data: ubigeos } = await res.json();
  if (ubigeos.length > 0) {
    return ubigeos;
  }
  return [];
}

export const getCountries = async () => {
  const ubigeoUrl = `/countries.json`;
  const res = await fetch(ubigeoUrl);
  const countries = await res.json();
  if (countries.length > 0) {
    return countries;
  }
  return [];
}
